import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const NotesSectionSkeleton = () => (
    <FormSection
        headline="Notes"
        info={() => (
            <Item grow={1}>
                <Group justify="space-between" alignItems="center">
                    <SkeletonItem width={58} height={28}/>
                    <SkeletonItem width={23} height={18}/>
                </Group>
            </Item>
        )}>
        <Group wrap="wrap" gap="none">
            {Array.from({length: 20}, (word, i) => (
                <Item key={i} style={{padding: '0px 8px 4px 0px'}}>
                    <SkeletonItem width={Math.random() * 100} height={18}/>
                </Item>
            ))}
        </Group>
    </FormSection>
);
